import { toOrderLineItem } from "../../../../../line-item/Orders/mappers/view/line-item/order-line-item.js";
import { toDrafts } from "../../../../../../server/Orders/mappers/server/to-drafts.js";
import { isSupportedLineItem } from "../../../../../utils/Orders/mappers/view/utils/order-line-item-product-type-guards.js";
import { getShipmentStatusLabel } from "../../../../../utils/Orders/mappers/view/utils/get-shipment-status-label.js";
import { getOrderStatusLabel } from "../../../../../utils/Orders/mappers/view/utils/get-order-status-label.js";
const toOverviewOrder = (order, intl, options = {}) => {
  const lineItems = order.lineItems.filter(isSupportedLineItem);
  return {
    drafts: toDrafts(lineItems),
    lineItems: lineItems.map((lineItem) => toOrderLineItem(intl, options, lineItem)),
    orderNumber: order.orderNumber,
    orderDate: new Date(order.orderDate),
    paymentStatus: order.paymentStatus ?? "",
    orderStatus: getOrderStatusLabel(order.state, intl),
    shipmentStatus: getShipmentStatusLabel(order.shipmentStatus, intl)
  };
};
export {
  toOverviewOrder
};
//# sourceMappingURL=order-overview.js.map
